// Cross-platform flag renderer.
//
// Unicode flag emojis (🇦🇼 🇨🇼 …) do not render on Windows, some Android
// keyboards, and older Linux distros — the OS shows the 2-letter fallback
// instead. This component renders each flag as an <img> served from the
// Twitter Twemoji CDN so users get a real flag glyph everywhere.
//
// Usage:  <Flag emoji="🇦🇼" size={16} />
//         <Flag code="aw" size={16} />
import React from "react";

// Twemoji encodes each regional-indicator letter as a codepoint pair like
// 1f1e6 (A) … 1f1ff (Z). A country flag is `1f1{X}-1f1{Y}` where X, Y map
// A→e6, B→e7, …, Z→ff.
const _regionalHex = (letter) => {
  const code = letter.toUpperCase().charCodeAt(0) - 65 + 0x1f1e6;
  return code.toString(16);
};

const _twemojiFilename = (codepoints) => codepoints.join("-");

const _fromEmoji = (emoji) => {
  const chars = [...emoji];
  return chars.map((c) => c.codePointAt(0).toString(16));
};

const _fromCode = (code) => {
  const letters = code.slice(0, 2).toUpperCase();
  return [_regionalHex(letters[0]), _regionalHex(letters[1])];
};

export const Flag = ({ emoji, code, size = 16, alt = "", className = "" }) => {
  let hex;
  if (code === "globe" || emoji === "🌍" || emoji === "🌐") {
    hex = ["1f30d"];
  } else if (code) {
    hex = _fromCode(code);
  } else if (emoji) {
    hex = _fromEmoji(emoji);
  } else {
    return null;
  }
  const src = `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/${_twemojiFilename(hex)}.svg`;
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      draggable={false}
      className={`inline-block align-[-0.15em] ${className}`}
      style={{ width: size, height: size }}
      loading="lazy"
    />
  );
};
